import styled from "styled-components";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { fontSizes, lineHeights } from "@magicbi/ui-library";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
  min-width: 0;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2.5]};
`;

export const Label = styled.span`
  flex: 1;
  color: ${rawColors.text.mediumEmphasis};
  ${typographyMixin("caption", 3)}
`;

/** 11/16 600. */
export const Position = styled.span`
  color: ${rawColors.text.mediumEmphasis};
  ${typographyMixin("caption", 4)}
  font-size: ${fontSizes["11"]};
  line-height: ${lineHeights["16"]};
  font-weight: 600;
`;

export const Trigger = styled.button`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  width: 100%;
  height: 2.375rem;
  padding: 0 ${spacing[3]};
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.lg};
  background: ${({ theme }) => theme.colors.surface.primary};
  color: ${rawColors.text.highEmphasis};
  text-align: left;
  cursor: pointer;
  ${typographyMixin("body", 3)}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const TriggerLabel = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TriggerMeta = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${rawColors.text.mediumEmphasis};
  ${typographyMixin("caption", 4)}
`;

export const Chevron = styled.span`
  display: inline-flex;
  margin-left: auto;
  color: ${rawColors.text.lowEmphasis};
`;
